import { render, staticRenderFns } from "./proy-programas.vue?vue&type=template&id=3b51fb1a"
import script from "./proy-programas.vue?vue&type=script&lang=js"
export * from "./proy-programas.vue?vue&type=script&lang=js"
import style0 from "./proy-programas.vue?vue&type=style&index=0&id=3b51fb1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports